module.exports = __webpack_public_path__ + "img/cs_get.4af16f1.png";